import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class NavigationStateService {
  private stateKey = 'navigationState'; // Clé pour localStorage

  public setState(key:string, data: any) {
    localStorage.setItem(key, JSON.stringify(data)); // Sauvegarde dans localStorage
  }

  public getState(key:string): any {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : null; // Lecture depuis localStorage
  }

  clearState() {
    localStorage.removeItem(this.stateKey); // Nettoyer le state si nécessaire
  }
}
